<template>
    <div>
      <div class="row">
        <div class="col-6 p-3">
          <Overview v-if="this.loadData" :data="this.loadData"></Overview>
        </div>
        <div class="col-6 p-3">
          <Statistics v-if="this.loadData" :data="this.loadData"></Statistics>
        </div>
      </div>
    </div>
  </template>
  
  <script>

import Overview from './components/Overview.vue';
import Statistics from './components/Statistics.vue'
import AdminService from './admin-service'

  export default {
    name: 'Dashboard',
    components: {
      Overview,
      Statistics,
      AdminService
    },
    data() {
      return {
        loadData: [],
      }
    },
    mounted: function () {
      AdminService.getStatics('all').then((response) => {
        this.loadData = response['data']
      });
    },
    methods: {

    },
  }
  </script>

  